import { CSSZAddress } from '../Interfaces/CSSZ.interface';
import { DeepPartial } from '../../../Interfaces/DeepPartial';
import { formatCSSZAddress } from './CSSZ.helper';

export interface CsszPatientAddressRow {
	street?: string;
	descriptiveNumber?: string;
	guideNumber?: string;
	city?: string;
	postCode?: string;
	countryCode?: string;
}

export function mapCsszRegistryAddressRowToPatientFormFields(
	row: CsszPatientAddressRow,
): {
	fields: DeepPartial<CSSZAddress>;
	countryCode?: string;
} {
	const fields: DeepPartial<CSSZAddress> = {
		street: row.street,
		descriptiveNumber: row.descriptiveNumber,
		guideNumber: row.guideNumber,
		city: row.city,
		postCode: row.postCode,
	};

	return {
		fields,
		countryCode: row.countryCode,
	};
}

export function formatCsszRegistryAddressRowPreview(
	row: CsszPatientAddressRow,
): string {
	const { fields } = mapCsszRegistryAddressRowToPatientFormFields(row);
	return formatCSSZAddress(fields);
}
